<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogExclusao" persistent max-width="500">
            <v-list-tile-title slot="activator" @click="$emit('acao-ativada')">Excluir</v-list-tile-title>
            <az-confirm v-if="mostrarDialogExclusao"
                        @onConfirm="excluirLicitacao"
                        @onDecline="mostrarDialogExclusao = false"
                        :maxWidth=320>
                Deseja realmente excluir o Credenciamento?
            </az-confirm>
        </v-dialog>
    </v-list-tile>
</template>

<script>
    import {mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'

    export default {
        name: 'CredenciamentoAtualizacaoAcoesExcluir',
        props:{
          licitacaoPublicada:{
            type: Boolean,
            default: null
          }
        },
        data() {
            return {
                mostrarDialogExclusao: false,
                justificativa: null
            }
        },
        methods: {
            async excluirLicitacao() {
                await this.$store.dispatch(actionTypes.CREDENCIAMENTO.REMOVER_CREDENCIAMENTO, {
                  credenciamentoId:this.licitacao.id
                })
                this.$router.push({name: 'licitacaoBusca'})
                this.mostrarNotificacaoSucessoDefault()
            },
        },
        computed: {
            ...mapState(['licitacao']),
        }
    }
</script>